module.exports = __webpack_public_path__ + "img/convenio-de-practicas2.f9327885.png";